const showElementsOnScroll = () => {
  let targets = document.querySelectorAll('[data-visibility]')

  const doWhenIntersect = function (entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.dataset.visibility = 'true'
      }
    })
  }

  const observer = new IntersectionObserver(doWhenIntersect)

  targets.forEach(function (target) {
    observer.observe(target)
  })
}

export default showElementsOnScroll